"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleFilterButton = void 0;
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importDefault(require("react"));
var select_1 = require("../../../select");
var config_context_1 = require("../../../_util/config-context");
function SingleFilterButton(_a) {
    var all = _a.all, className = _a.className, style = _a.style, children = _a.children, options = _a.options, value = _a.value, selectProps = tslib_1.__rest(_a, ["all", "className", "style", "children", "options", "value"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    var active = Boolean(value);
    if (all) {
        options = tslib_1.__spread([all], options); // eslint-disable-line no-param-reassign
        active = value !== all.value;
    }
    return (react_1.default.createElement("span", { className: classnames_1.default(classPrefix + "-table__filterbtn", { "is-active": active }, className), style: style },
        react_1.default.createElement(select_1.Select, tslib_1.__assign({}, selectProps, { type: "simulate", appearance: "filter", button: children, options: options.map(function (_a) {
                var label = _a.label, text = _a.text, option = tslib_1.__rest(_a, ["label", "text"]);
                return (tslib_1.__assign(tslib_1.__assign({}, option), { text: text || label }));
            }), value: value }))));
}
exports.SingleFilterButton = SingleFilterButton;
//# sourceMappingURL=SingleFilterButton.js.map